module.exports = __webpack_public_path__ + "img/9791188810055.3f43c882.jpg";